<template>
  <div  v-loading="loading">
    <div class="document-form">
      <div v-if="!documentsForm.documents.length"><h4 style="color:#606266"> No documents </h4></div>
      <el-form ref="documentsForm" :label-position="labelPosition" :model="documentsForm">
        <el-form-item prop="docIdValues">
            <div v-for="addlItem in documentsForm.addlReportTypes" :key="addlItem.id">
              <el-checkbox-group v-model="documentsForm.docIdValues">
                <h4 style="font-weight: 600;color:#7cc1eb"> {{addlItem.reportTypeName}}</h4>
                <div v-for="item in docsPerReportType(addlItem.id)" :key="item.id">
                  <el-checkbox style="padding-bottom:3px" :label="item.id">{{item.documentName}}</el-checkbox> <br>
                 </div>
              </el-checkbox-group>
            </div>
        </el-form-item>
        <div v-if="documentsForm.documents.length">
          <el-button size="small" type="primary" style="font-family: Calibri; font-size: 15px; font-weight: 200; background: #202c4c; margin:0 auto; display:block;" @click="onSubmit">Download</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>

import HTTP_API from '@/utils/http-api'
export default {
  name: 'Library',
  data () {
    return {
      loading: true,
      labelPosition: "right",
      documentsForm: {
        docIdValues: [],
        documents: [],
        addlReportTypes:[]
      }
    }
  },
  methods:{
    getLibraryData(){
      var vm = this
      vm.loading = true;
      HTTP_API.get('/library/librarydashboard')
      .then(response => {
        vm.documentsForm.documents = response.data.documents
        vm.documentsForm.addlReportTypes = response.data.addlReportTypes
        vm.resetAllFlag();
      })
      .catch(function (error) {
        console.log(error.response)
        vm.resetAllFlag();
      })
    },
    onSubmit() {
      var vm = this
      var fileName = 'Documents.zip'
      var docIdsParam = '';
      for (var index =0 ;index < vm.documentsForm.docIdValues.length ;index++){
        docIdsParam = docIdsParam + vm.documentsForm.docIdValues[index] + ",";
      }
      
      vm.documentsForm.docIdValues =[];
      HTTP_API.get('/library/downloadreport/' +  docIdsParam,{responseType: 'blob'})
      .then(response => {
        var disposition =response.headers['content-disposition']
        if (disposition && disposition.indexOf('inline') !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) { 
            fileName = matches[1].replace(/['"]/g, '');
          }
        }
        if (window.navigator.msSaveOrOpenBlob) {
          // IE11
          window.navigator.msSaveOrOpenBlob(response.data, `${fileName}`)
        } else {
          let url = window.URL.createObjectURL(response.data)
          let a = document.createElement('a')

          document.body.appendChild(a)
          a.href = url
          a.download = `${fileName}`
          a.click()
          
        }
      })
      .catch(function (error) {
        console.log(error.response)
        
      })   
    },
    resetAllFlag() {
      this.loading = false
    },
    docsPerReportType(reportTypeId){
      return this.documentsForm.documents.filter(doc => doc.reportType.id === reportTypeId)
    }
  },
  created() {
    this.getLibraryData()
  }
}
</script>

<style scoped>
.document-form {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    margin-right: 15px;
    margin-left: 350px;
    /* margin-top: 100px; */
    width: 700px;
    /* background: rgba(255, 255, 255, .9); */
    background: #f2f2f2;
    opacity: 0.96;
    border: 2px solid #7cc1eb;
}
</style>
